<template>
  <div>
    <b-row class="no-gutters px-3 px-sm-0">
      <b-col md="8">
        <h1 class="mr-sm-4 header-tablepage">PERSONAL CUSTOMER</h1>
      </b-col>
    </b-row>
    <b-container class="no-gutters bg-white mt-3">
      <b-row>
        <b-col
          v-for="items of menu"
          cols="6"
          class="pointer my-3"
          @click.prevent="$router.push(items.path)"
          :key="items.id"
        >
          <div class="bg-icon shadow-sm">
            <font-awesome-icon :icon="items.icon" size="lg" />
          </div>
          <div class="content">
            <div class="ft-weight" style="text-transform: uppercase">
              {{ items.title }}
            </div>
            <div class="ft-10">{{ items.desc }}</div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <FooterAction routePath="/setting" :hideSubmit="true" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      menu: [
        {
          id: 0,
          title: "Title",
          desc: "คำนำหน้า",
          path: "/setting/personal/setting/2",
          icon: "text-height",
        },
        {
          id: 1,
          title: "gender",
          desc: "เพศ",
          path: "/setting/personal/setting/21",
          icon: "venus-mars",
        },

        {
          id: 2,
          title: "Register Form",
          desc: "ตั้งค่าแบบฟอร์มลงทะเบียน",
          path: "/setting/personal/form",
          icon: "address-book",
        },
        {
          id: 2,
          title: "Register Form (Email Login)",
          desc: "ตั้งค่าแบบฟอร์มลงทะเบียน สำหรับ Email Login",
          path: "/setting/personal/form/email",
          icon: "address-book",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.bg-icon {
  background-color: var(--theme-secondary-color);
  width: 50px;
  height: 50px;
  border-radius: 10px;
  color: var(--primary-color);
  padding: 15px;
  text-align: center;
}
.content {
  position: absolute;
  top: 5px;
  margin-left: 60px;
}
.ft-10 {
  font-size: 10px;
}
.ft-weight {
  font-weight: 600;
}
</style>
